const ELLIPSIS = '...';

export const TRUNCATE_MAX = {
  TOAST: 50,
  TOAST_FILE_NAME: 30,
  NOTIFICATION: 20,
  BREADCRUMB: 50,
  PAGE_HEADER: 30,
} as const;

export const isTruncatedString = (
  text: string,
  maxVisibleLength: number
): boolean => text.length > maxVisibleLength;

export const truncateString = (
  text: string,
  maxVisibleLength: number
): string => {
  if (maxVisibleLength <= 0) {
    return '';
  }

  if (!isTruncatedString(text, maxVisibleLength)) {
    return text;
  }

  if (maxVisibleLength <= ELLIPSIS.length) {
    return ELLIPSIS.slice(0, maxVisibleLength);
  }

  return `${text.slice(0, maxVisibleLength - ELLIPSIS.length)}${ELLIPSIS}`;
};

export const truncateFileName = (
  fileName: string,
  extension: string,
  maxNameLength: number
): string => {
  const fullFileName = `${fileName}${extension}`;

  if (!isTruncatedString(fullFileName, maxNameLength)) {
    return fullFileName;
  }

  return `${truncateString(fileName, maxNameLength - extension.length)}${extension}`;
};
